export default __webpack_public_path__ + "static/media/c007-1.5770f10d.jpg";